// Editing an issue draft (see `GET /api/feedback/:id/issue`).

/** `body` with `line` (the screenshot's link, as the server writes it) at its end when `on`, and nowhere in it when not. */
export function toggleLine(body: string, line: string, on: boolean): string {
  if (!line) return body;
  const without = body.includes(line) ? body.replace(line, '') : body;
  if (!on) return without;
  return without.endsWith('\n') || !without ? without + line : `${without}\n${line}`;
}
